export interface HeartConvoObject {
  id?: number;
  content?: string;
  audio?: string;
  duration?: string;
  characterImage?: string;
  textColor?: string;
}

export interface HeartConvo {
  object: HeartConvoObject[];
}

export interface HeartEmoji {
  image: string;
  level: string[];
  linkTo: string;     // "id:NN"
  emojiText: string;
}

export interface HeartTile {
  id: number;
  title: string;
  linkTo: string;
  icon: string;
  audio?: string;
}

export interface HeartUserAction {
  id: number;
  component: string;  // "block.emotion" | "block.tiles-input" | "block.button-input"
  buttonText?: string;
  emojis?: HeartEmoji[] | null;
  tiles?: HeartTile[] | null;
  linkTo?: string | null;
}

export interface HeartBlock {
  id: number;
  name?: string;
  blockType?: string;        // "Heart Block" | "Emotion Block"
  heartBlockType?: string;   // "Pre-limit" | "Post-limit"
  conversations: HeartConvo[];
  userActions?: HeartUserAction[];
  bgImage?: string;
  bgImageTab?: string;
}

export type HeartScreen = "HeartCorner" | "Feeling" | "WriteAboutIt";

/** Convert "id:31" → 31 (mobile: convertStringToID) */
export function convertStringToID(linkTo?: string): number | null {
  if (!linkTo) return null;
  const m = linkTo.match(/id:(\d+)/i);
  return m ? parseInt(m[1], 10) : null;
}
